@import (reference) '../../styles/variables.less';
@import (reference) '../../styles/functions.less';

// For some unknown reason, we're using the color that is not included in the Style Guide.
@unique-footer-link-color: #00aeef;

:host {
  background-color: @lt-blue-deep;
  color: @white;
  display: block;
  font: @lt-font-primary;
  text-align: left;
}

.container {
  container-name: main;
  container-type: inline-size;
  margin: 0 auto;
  max-width: @screen-lg;
}

footer {
  display: grid;
  grid-template:
    "about-us legal sites social-apps"
    "about-us legal sites security"
    "disclaimer disclaimer disclaimer ."
    auto / 1fr 1fr 1fr 1.5fr
  ;
  margin: @spacer-5 @spacer-6;

  @container main (width < calc(@screen-lg - @spacer-6 - @spacer-6)) {
    grid-template:
      "about-us legal sites"
      "social-apps social-apps social-apps"
      "disclaimer disclaimer disclaimer"
      "security security security"
      auto / 1fr 1fr 1fr
    ;
    margin: @spacer-4 @spacer-5;
  }

  @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
    grid-template:
      "about-us legal"
      "sites sites"
      "social-apps social-apps"
      "disclaimer disclaimer"
      "security security"
      auto / 1fr 1fr
    ;
    margin: @spacer-3 @spacer-4;
  }
}

ul {
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
}

li {
  .font-size-em(12);

  padding-bottom: @spacer-3;
}

h3 {
  .font-size-em(14);

  margin-top: 0;
}

a, button {
  appearance: none;
  background: none;
  border: none;
  color: @unique-footer-link-color;
  cursor: pointer;
  font-family: inherit;
  font-size: 1em;
  margin: 0;
  padding: 0 2px 0 0;
  text-align: left;
  text-decoration: none;

  &:visited {
    color: @unique-footer-link-color;
  }

  &:hover,
  &:active {
    color: @white;
  }

  &.social {
    display: inline-block;
    height: 46px;
    width: 46px;
  }

  &.app {
    display: inline-block;
    width: 130px;
  }

  &.business {
    display: inline-block;
    width: 40px;
  }
}

button.privacy-choices {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}

.law-text {
  color: @lt-gray-dark-1;
  .font-size-em(12);
  .line-height(20, 12);

  a {
    text-decoration: underline;
  }
}

.horizontal-list {
  align-items: flex-end;
  display: flex;
  gap: @spacer-2b;
  justify-content: flex-start;

  &.businesses {
    gap: @spacer-6;
  }

  li {
    padding-bottom: 0;
  }
}

.no-padding {
  padding: 0;
}

// Grid areas

.about-us {
  grid-area: about-us;
  place-self: start start;
}

.legal {
  border-left: 1px solid @lt-gray-dark-3;
  grid-area: legal;
  padding-left: @spacer-3;
  place-self: start start;

  @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
    border-left: none;
    padding-left: 0;
  }
}

.sites {
  border-left: 1px solid @lt-gray-dark-3;
  grid-area: sites;
  padding-left: @spacer-3;
  place-self: start start;

  @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
    border-bottom: 1px solid @lt-gray-dark-3;
    border-left: none;
    border-top: 1px solid @lt-gray-dark-3;
    justify-self: stretch;
    margin-top: @spacer-5;
    padding-bottom: @spacer-5;
    padding-left: 0;
    padding-top: @spacer-5;
  }
}

.apps,
.socials {
  h3 {
    @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
      text-align: center;
    }
  }
}

.social-apps {
  display: flex;
  flex-direction: column;
  gap: @spacer-5;
  grid-area: social-apps;

  @container main (width < calc(@screen-lg - @spacer-6 - @spacer-6)) {
    flex-direction: row;
    padding-top: @spacer-5;
  }

  @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
    align-items: center;
    flex-direction: column;
  }
}

.security {
  grid-area: security;

  @container main (width < calc(@screen-lg - @spacer-6 - @spacer-6)) {
    padding-top: @spacer-5;
  }

  @container main (width < calc(@screen-md - @spacer-5 - @spacer-5)) {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}

.disclaimer {
  grid-area: disclaimer;
  padding-right: @spacer-6;
  padding-top: @spacer-5;

  @container main (width < calc(@screen-lg - @spacer-6 - @spacer-6)) {
    padding-right: 0;
  }
}
